import * as React from 'react';

const CalendarRepeatFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="calendar-repeat-fill_svg__a"
                d="M20 5H0V2h5V0h1v2h8V0h1v2h5v3zm0 1v14H0V6h20zm-7 4.357A4 4 0 1010 17c.9 0 1.73-.3 2.398-.803l-.6-.8A2.98 2.98 0 0110 16c-1.654 0-3-1.346-3-3s1.346-3 3-3c.886 0 1.682.387 2.23 1H11v1h3V9h-1v1.357z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 2)">
            <mask id="calendar-repeat-fill_svg__b" fill="#fff">
                <use xlinkHref="#calendar-repeat-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#calendar-repeat-fill_svg__a" />
            <g mask="url(#calendar-repeat-fill_svg__b)">
                <path fill="#000" d="M-2-2h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CalendarRepeatFillSvg.displayName = 'CalendarRepeatFillSvg';
export default CalendarRepeatFillSvg;
